export default class AssessmentsRankPillars {

  constructor() {}

  render() {

    // Sortable cards
    $('#sortablePillars').sortable({
      placeholder: "available-pillar-space",
      scroll: false,
      update: function(event, ui) {
        let sortOrder = $(this).sortable('toArray');
        $.each(sortOrder, function(ind, pillarId) {
          $('#' + pillarId).find('.hidden-sort-order').val(ind + 1);
        });
      }
    });

    // Submit form (custom button text doesn't work with default Rails f.submit)
    $('.submit-pillars').click(function() {
      $('#assessment_lead_rank_pillars_form').submit();
    })

  }

}